/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FormattedMessage } from 'react-intl';

import success from 'images/success.png';

import { AccessReadyProps, ACCESS_READY_FLOW } from './types';

import * as S from '../styles';
import * as SS from './styles';

const AccessReady: React.FC<AccessReadyProps> = ({
  onAccessReady,
  accessReadyFlow,
}) => {
  const message = () => {
    switch (accessReadyFlow) {
      case ACCESS_READY_FLOW.FIRST_LOGIN:
        return 'LOGIN.ACCESS_READY.TITLE.FIRST_LOGIN';
      case ACCESS_READY_FLOW.TEMPORARY_PASSWORD_RECOVERY:
        return 'LOGIN.ACCESS_READY.TITLE.TEMPORARY_PASSWORD_RECOVERY';
      case ACCESS_READY_FLOW.NORMAL_LOGIN:
      default:
        return 'LOGIN.ACCESS_READY.TITLE.NORMAL_LOGIN';
    }
  };

  const handleActionKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const keyCode = e.which || e.key;

    if (keyCode === 13) {
      e.preventDefault();
      onAccessReady();
    }
  };

  return (
    <SS.Container onKeyDown={handleActionKeyDown} data-testid="accessReadyStep">
      <SS.ImageContainer>
        <img src={success} alt="success" />
      </SS.ImageContainer>

      <S.Title>
        <FormattedMessage id={message()} />
      </S.Title>

      <S.ActionButtonContainer>
        <S.ActionButton
          onClick={onAccessReady}
          data-testid="accessReadyActionButton"
        >
          <FormattedMessage id="LOGIN.ACCESS_READY.ACTION.CONTINUE" />
        </S.ActionButton>
      </S.ActionButtonContainer>
    </SS.Container>
  );
};

export default AccessReady;
